import { Kelvin } from "@/libs/units/temperature";

import type { GasVolumeCompressibilityCalculator } from "../d";

export const californiaNGACompressibilityCalculator: GasVolumeCompressibilityCalculator =
  params => {
    const { gasSpecificGravity, inSituPressurePSIA, temperatureF } = params;
    // D87: =(D4-32)*5/9+273.15
    const inSituTemperatureKelvin = Kelvin.toThisUnit(temperatureF);

    // D89: =D3/145.03773773
    const inSituPressureMPA = inSituPressurePSIA / 145.03773773;

    // D91: =1/(1+((5.072*10^6*D89*10^(1.785*D32))/(D87^3.825)))
    const gasCompressibilityFactor =
      1 /
        (1 +
          (5.072 *
            10 ** 6 *
            inSituPressureMPA *
            10 ** (1.785 * gasSpecificGravity)) /
            inSituTemperatureKelvin ** 3.825) || 0;

    return {
      gasCompressibilityFactor,
      intermediates: {
        inSituPressurePSIA,
        temperatureF,
        inSituTemperatureKelvin,
        inSituPressureMPA
      }
    };
  };
